/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"

import SEO from "./seo"
import Footer from "./footer"
import Header from "./header"

const Layout = ({
  children,
  header,
  subMenu,
  button,
  isContent,
  parent,
  siteTitle,
  main = false,
}) => {
  return (
    <div>
      <SEO subTitle={siteTitle} />
      <div
        className="d-none d-lg-block"
        style={{ minHeight: (main ? "96px" : "156px"), marginTop: (main ? "40px" : "") }}
      ></div>
      <div className="d-lg-none d-xs-block" style={{ minHeight: "60px", marginTop: (main ? "60px" : "") }}></div>
      <Header
        siteTitle={siteTitle}
        marquee={header}
        menus={subMenu}
        button={button}
        isContent={isContent}
        parent={parent}
      />
      {children}
      <Footer />
    </div>
  )
}

export default Layout
